import React, { useState } from "react";
import PaginationButton from "../commanComponents/buttons/PaginationButton";
import BorderButton from "../commanComponents/buttons/BorderButton";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { PaginationContext } from "../constants/context/PaginationProvider";
import useDebounce from "../constants/helpers/useDebounce";
import { communication } from "../constants/apis/communication";
import toast from "react-hot-toast";
import Loader from "../commanComponents/Loader";
import SelectMine from "../commanComponents/SelectMine";
import svgData from "../constants/utilities/svgData";
import { formatDate } from "../constants/helpers/helperFunctions";
import { getUserDetails } from "../constants/helpers/getUserDetails";

export default function GangMaster() {
  const navigate = useNavigate();
  const { globalSearchString } = React.useContext(PaginationContext);
  const [page, setPage] = useState(1);
  const debouncedSearchTerm = useDebounce(globalSearchString, 1000, setPage);
  const [expandedRow, setExpandedRow] = useState(null);
  const [selectedMine, setSelectedMine] = useState(getUserDetails()?.mineId || "");

  const { data: gangMaster, isFetching } = useQuery(["getGangMasterList", page, debouncedSearchTerm], () => communication?.getGangMasterList({ searchString: debouncedSearchTerm, page }), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status === "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      } else if (data?.data?.status === "FAILED") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  return (
    <>
      {isFetching && <Loader />}
      <div className="pageWrapper">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 bg-white p-3 rounded comman-box-shadow">
          <div className="d-flex gap-3 flex-wrap">
            <BorderButton text="Employee Master" icon={svgData?.employeeMasterIcon} onClick={() => navigate("/panel/settings/employee-master")} isActive={false} />
            <BorderButton text="Equipment Master" icon={svgData?.hammerIcon} onClick={() => navigate("/panel/settings/equipment-master")} isActive={false} />
          </div>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <SelectMine selectedMine={selectedMine} onChange={(e) => setSelectedMine(e.target.value)} />
            <PaginationButton setPage={setPage} page={page} totalPages={gangMaster?.data?.totalPages} />
            <div className="d-flex gap-2 lightBlueColor align-items-center cursor-pointer" onClick={() => navigate(-1)} style={{ marginLeft: "12px" }}>
              <p style={{ fontSize: "16px", margin: 0, fontWeight: "600" }}>Back</p>
              <div>{svgData?.backButton}</div>
            </div>
          </div>
        </div>

        <div className="mt-2">
          <div className="tableWrapper comman-box-shadow p-2 d-flex flex-column gap-5" style={{ position: "relative", height: "70vh" }}>
            {gangMaster?.data?.gang?.map((data, index) => {
              return (
                <div>
                  <div
                    className="gangCardWrapper"
                    //  onClick={() => toggleRow(index)}
                  >
                    <div className="d-flex gap-5">
                      <div className=" d-flex gap-2">
                        Gang No:
                        <div>{data?.[0]?.gangNo || "--"}</div>
                      </div>
                      <div className="d-flex gap-2">
                        No. Of Employee:
                        <div>{data?.length || "0"}</div>
                      </div>
                    </div>
                    {/* <div>
                      {expandedRow == index ? svgData?.upArrow : svgData?.downArrow}
                    </div> */}
                  </div>
                  {/* {expandedRow == index && ( */}
                  <div className="expandedTableWrapper">
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center col_80px">Sr. No.</th>
                          <th className="col_350px">Name of Employee or Applicant</th>
                          <th className="col_200px">Gang No</th>
                          <th className="col_200px">Personnel Number</th>
                          <th className="col_200px">Personnel Area</th>
                          <th className="col_200px">Personnel Subarea</th>
                          <th className="col_200px">Start Date</th>
                          <th className="col_200px">End Date</th>
                          <th className="col_250px">IC Type</th>
                          <th className="col_200px">Identity Number</th>
                          <th className="col_200px">Employee Group</th>
                          <th className="col_200px">Employee Subgroup</th>
                          <th className="col_200px">Shift</th>
                          <th className="col_200px">Department</th>
                          <th className="col_200px">Section</th>
                          <th className="col_200px">Level</th>
                          <th className="col_200px">Stope</th>
                          <th className="col_200px">Allocation</th>
                          <th className="col_200px">Asst Gangman</th>
                          <th className="col_200px">Gang Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((ele, i) => {
                          return (
                            <tr onClick={() => toggleRow(index)}>
                              <td className="text-center">{i + 1}</td>
                              <td className="text-uppercase">{ele?.nameOfEmployee || "--"}</td>
                              <td className="text-uppercase">{ele?.gangNo || "--"}</td>
                              <td className="text-uppercase">{ele?.personnelNumber || "--"}</td>
                              <td className="text-uppercase">{ele?.personnelArea || "--"}</td>
                              <td className="text-uppercase">{ele?.personnelSubarea || "--"}</td>
                              <td className="text-uppercase">{ele?.startDate ? formatDate(ele?.startDate) : "--"}</td>
                              <td className="text-uppercase">{ele?.endDate || "--"}</td>
                              <td className="text-uppercase">{ele?.ICType || "--"}</td>
                              <td className="text-uppercase">{ele?.identityNumber || "--"}</td>
                              <td className="text-uppercase">{ele?.employeeGroup || "--"}</td>
                              <td className="text-uppercase">{ele?.employeeSubgroup || "--"}</td>
                              <td className="text-uppercase">{ele?.shift || "--"}</td>
                              <td className="text-uppercase">{ele?.department || "--"}</td>
                              <td className="text-uppercase">{ele?.section || "--"}</td>
                              <td className="text-uppercase">{ele?.level || "--"}</td>
                              <td className="text-uppercase">{ele?.stope || "--"}</td>
                              <td className="text-uppercase">{ele?.allocation || "--"}</td>
                              <td className="text-uppercase">{ele?.asstGangmen || "--"}</td>
                              <td className="text-uppercase">{ele?.gangType || "--"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {/* )} */}
                </div>
              );
            })}
            {(!gangMaster?.data?.gang || gangMaster?.data?.gang?.length === 0) && <h6 className="noDataAvailableWrapper">No Data Available</h6>}
          </div>
        </div>
      </div>
    </>
  );
}
